exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ChangePasswordForm-formControlpassWord-3di_L{\r\n    padding: 10px 45px 10px 19px;\r\n}", ""]);

// exports
exports.locals = {
	"formControlpassWord": "ChangePasswordForm-formControlpassWord-3di_L"
};